import React, { Component } from 'react';
// import PropTypes from "prop-types";

export class FeaturesPage extends Component {
  render() {
    return <div>FeaturesPage</div>;
  }
}

// https://reactjs.org/docs/typechecking-with-proptypes.html#proptypes
FeaturesPage.propTypes = {};

export default FeaturesPage;



// WEBPACK FOOTER //
// ./src/pages/FeaturesPage.js